import { mapGetters } from 'vuex';
import TranslationsMixin from '../../mixins/translations';
import TheExchangeSidebar from '../../components/TheExchangeSidebar/index.vue';

export default {
  name: 'ExchangeConfirmationView',
  mixins: [TranslationsMixin],
  components: {
    TheExchangeSidebar,
  },
  computed: {
    ...mapGetters('customer/', ['suppliedFormData']),
    ...mapGetters('order/', ['orderConfirmationResponse']),
    getOrderDate() {
      const locale = this.suppliedFormData?.selectedCountryRegion?.locale;

      if (locale) {
        return new Date().toLocaleDateString(locale.replace('_', '-'), {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      }

      return null;
    },
  },
};
